<template>
  <div id="app">
    <Header :data="HeaderInfo" :isHome="isHome"></Header>
    <router-view/>
    <Footer :data="FooterInfo" :icp="icp"></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
import { getPublicNav, getPublicWebInfo } from "@/api/api";
export default {
  name: 'App',
  data() {
    return {
      HeaderInfo: {},
      FooterInfo: {},
      icp: false,
      isHome: true,
    }
  },
  mounted() {
    this.getHomeInfo()
  },
  watch: {
    '$route'(to, from) {
      if (to.name === 'contact_us') {
        this.icp = true
      } else {
        this.icp = false
      }
      if (to.name === 'home') {
        this.isHome = true
      } else {
        this.isHome = false
      }
    }
  },
  methods: {
       getHomeInfo() {
        getPublicNav().then(res=> {
          if (res.status === 200) {
            this.HeaderInfo = res.success;
            console.log('菜单', this.HeaderInfo);
          }
        })
        getPublicWebInfo().then(res=> {
          if (res.status === 200) {
            this.FooterInfo = res.success;
          }
        })
      }
  }
}
</script>
<style lang="less">
@import '../src/assets/css/font.css';
</style>



// WEBPACK FOOTER //
// src/App.vue